import { PrimaryButton, TextField } from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import { isValidCpr, isValidCvr } from '../../utilities/validators';
import { getValidMail } from '../../utilities/validContactInformation';

const InviteeForm = ({
  cprValue,
  setCprValue,
  cvrValue,
  setCvrValue,
  emailValue,
  setEmailValue,
  onAddKey,
}) => {
  const { t: translator } = useTranslation();

  const isFormValid = () => {
    const hasAtLeastOneValue = cprValue || cvrValue || emailValue;
    const isCprValid = !cprValue || isValidCpr(cprValue);
    const isCvrValid = !cvrValue || isValidCvr(cvrValue);
    const isEmailValid = !emailValue || getValidMail(true)(emailValue);

    return hasAtLeastOneValue && isCprValid && isCvrValid && isEmailValid;
  };

  return (
    <div className="input-container">
      <h4>{translator('components.inviteeForm.addNewKey')}</h4>

      <div className="input">
        <TextField
          label={translator('components.inviteeForm.cprLabel')}
          value={cprValue}
          onChange={(_, value) => setCprValue(value || '')}
          placeholder={translator('components.inviteeForm.cprPlaceholder')}
          disabled={cvrValue !== '' || emailValue !== ''}
          deferredValidationTime={800}
          validateOnLoad={false}
          onGetErrorMessage={(value) =>
            !!value && !isValidCpr(value)
              ? translator('components.inviteeForm.cprValidationError')
              : ''
          }
        />
        <TextField
          label={translator('components.inviteeForm.cvrLabel')}
          value={cvrValue}
          onChange={(_, value) => setCvrValue(value || '')}
          placeholder={translator('components.inviteeForm.cvrPlaceholder')}
          disabled={cprValue !== '' || emailValue !== ''}
          deferredValidationTime={800}
          validateOnLoad={false}
          onGetErrorMessage={(value) =>
            !!value && !isValidCvr(value)
              ? translator('components.inviteeForm.cvrValidationError')
              : ''
          }
        />
        <TextField
          label={translator('components.inviteeForm.emailLabel')}
          value={emailValue}
          onChange={(_, value) => setEmailValue(value || '')}
          placeholder={translator('components.inviteeForm.emailPlaceholder')}
          disabled={cprValue !== '' || cvrValue !== ''}
          deferredValidationTime={800}
          validateOnLoad={false}
          onGetErrorMessage={(value) =>
            !!value && !getValidMail(true)(value)
              ? translator('components.inviteeForm.emailValidationError')
              : ''
          }
        />
      </div>

      <PrimaryButton
        text={translator('components.inviteeForm.addButton')}
        onClick={onAddKey}
        disabled={!isFormValid()}
      />
    </div>
  );
};

export { InviteeForm };
